import { initializeApp } from "firebase/app";
import { getAuth, signInAnonymously } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCV8VnaGDRM-1lQpNX2XKcy7QRF2l8Kwms",
  authDomain: "forza-logistics.firebaseapp.com",
  projectId: "forza-logistics",
  storageBucket: "forza-logistics.firebasestorage.app",
  messagingSenderId: "751537440152",
  appId: "1:751537440152:web:e84f1a588af32b93f5d7ed",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);


// Call this right after GSheet login succeeds
export const activateFirebaseSession = async () => {
  try {
    const currentUser = auth.currentUser;
    if (!currentUser) {
      await signInAnonymously(auth); // Firebase now knows someone logged in
    }
  } catch (err) {
    console.error("Firebase session error:", err);
  }
};